import { render } from "./InfoPopup.vue?vue&type=template&id=4df3d0d2"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/InfoPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4df3d0d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4df3d0d2', __exports__)) {
    api.reload('4df3d0d2', __exports__)
  }
  
  module.hot.accept("./InfoPopup.vue?vue&type=template&id=4df3d0d2", () => {
    api.rerender('4df3d0d2', render)
  })

}


export default __exports__